"use client"

import { SIGN_UP_SHARE_CODE_URL_KEY } from "@/constants/shareCode"
import { useToasts } from "@/hooks/Toasts"
import { ConfigProvider, Modal } from "antd"
import clsx from "clsx"
import Image from "next/image"
import Link from "next/link"
import { AlertCircle, Check } from "react-feather"
import facebookGrayPng from "../../assets/images/rewards-program/facebook-gray.png"
import facebookPng from "../../assets/images/rewards-program/facebook.png"
import linkGrayPng from "../../assets/images/rewards-program/link-gray.png"
import linkPng from "../../assets/images/rewards-program/link.png"
import mailPng from "../../assets/images/rewards-program/mail-gray.png"
import mailGaryPng from "../../assets/images/rewards-program/mail.png"
import pinterestGrayPng from "../../assets/images/rewards-program/pinterest-gray.png"
import pinterestPng from "../../assets/images/rewards-program/pinterest1.png"
import twitterGrayPng from "../../assets/images/rewards-program/twitter-gray.png"
import twitterPng from "../../assets/images/rewards-program/twitter.png"

// SSR 期无 location，加守卫避免服务端渲染报错（该值仅在客户端分享时用到）
const origin = typeof window !== "undefined" ? window.location.origin : ""

const ShareSignUpLinkModal = (props) => {
  const [, { addToast }] = useToasts()
  const { open, onCancel, shareCode } = props

  const createAccountUrl = `${origin}/create-account?${SIGN_UP_SHARE_CODE_URL_KEY}=${shareCode}`

  const sharePlatformConfigs = [
    {
      src: facebookGrayPng,
      activeSrc: facebookPng,
      href: `http://www.facebook.com/sharer.php?u=${createAccountUrl}`,
    },
    {
      src: pinterestGrayPng,
      activeSrc: pinterestPng,
      href: `http://pinterest.com/pin/create/button/?url=${createAccountUrl}`,
    },
    {
      src: twitterGrayPng,
      activeSrc: twitterPng,
      href: `https://twitter.com/intent/tweet?url=${createAccountUrl}`,
    },
    {
      src: mailPng,
      activeSrc: mailGaryPng,
      href: `mailto:?body=${encodeURIComponent(createAccountUrl)}`,
    },
    {
      src: linkGrayPng,
      activeSrc: linkPng,
      onClick: () => {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(createAccountUrl)
            .then(() => {
              addToast({
                type: "success",
                icon: <Check />,
                message: "Link copied to clipboard!",
              })
            })
            .catch((err) => {
              addToast({
                type: "error",
                icon: <AlertCircle />,
                message: "Failed to copy link!",
              })
            })
        } else {
          addToast({
            type: "error",
            icon: <AlertCircle />,
            message: "Failed to copy link!",
          })
        }
      },
    },
  ]

  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 0,
        },
      }}
    >
      <Modal
        open={open}
        width={800}
        footer={null}
        className={clsx(
          "lg_[&_.ant-modal-content]_px-[0px] lg_[&_.ant-modal-content]_py-[60px]",
          "[&_.ant-modal-content]_px-3 [&_.ant-modal-content]_py-8"
        )}
        centered
        onCancel={onCancel}
      >
        <h2 className="font-poppins text-center text-lg font-normal leading-[30px] text-primary lg_text-xl">
          SHARE TO EARN POINTS
        </h2>

        <div className="mt-4 flex items-center justify-center gap-x-4 lg_mt-[50px] lg_gap-x-[43px]">
          {sharePlatformConfigs.map(({ src, activeSrc, onClick, href }, i) => {
            const imageNode = (
              <>
                <Image
                  width={40}
                  height={40}
                  src={src}
                  alt="facebook"
                  className="w-7 lg_w-10 lg_group-hover_hidden"
                />
                <Image
                  width={40}
                  height={40}
                  src={activeSrc}
                  alt="facebook"
                  className="hidden w-7 lg_w-10 lg_group-hover_block"
                />
              </>
            )

            return (
              <div
                key={i}
                className="group cursor-pointer"
                onClick={() => {
                  onClick?.()
                }}
              >
                {href ? (
                  <Link href={href} target="_blank">
                    {imageNode}
                  </Link>
                ) : (
                  imageNode
                )}
              </div>
            )
          })}
        </div>
        <div className="m-4 h-px bg-info lg_mx-[60px] lg_mb-[30px] lg_mt-[38px]" />
        <p className="mx-4 font-sans  text-sm font-semibold leading-[30px] text-paragraph lg_mx-[60px] lg_text-[18px]">
          STEP 01.Share Link
        </p>
        <p className="mx-4 font-sans  text-sm font-semibold leading-[30px] text-paragraph lg_mx-[60px] lg_text-[18px]">
          STEP 02.Your Friend Must Tap The Link To Sign Up.
        </p>
        <p className="mx-4 font-sans  text-sm font-semibold leading-[30px] text-paragraph lg_mx-[60px] lg_text-[18px]">
          STEP 03.You Got 100 Points, Your Friend Got 100 Points.
        </p>
      </Modal>
    </ConfigProvider>
  )
}

export default ShareSignUpLinkModal
